module.exports = __webpack_public_path__ + "static/media/nextArrowCarousel.7706ae03.svg";